import { MPA_DPA_ACTIONS } from "constants/actions";

export function fetchBusinessProductList() {
    return {
        type: MPA_DPA_ACTIONS.FETCH_BUSINESS_PRODUCT_LIST
    };
}

export function fetchedBusinessProductList(data) {
    return {
        type: MPA_DPA_ACTIONS.FETCHED_BUSINESS_PRODUCT_LIST,
        payload: {
            data
        }
    };
}

export function failedFetchBusinessProductList(error) {
    return {
        type: MPA_DPA_ACTIONS.FAILED_FETCH_BUSINESS_PRODUCT_LIST,
        payload: {
            error
        }
    };
}

export function fetchBusinessProgramList() {
    return {
        type: MPA_DPA_ACTIONS.FETCH_BUSINESS_PROGRAM_LIST
    };
}

export function fetchedBusinessProgramList(data) {
    return {
        type: MPA_DPA_ACTIONS.FETCHED_BUSINESS_PROGRAM_LIST,
        payload: {
            data
        }
    };
}

export function failedFetchBusinessProgramList(error) {
    return {
        type: MPA_DPA_ACTIONS.FAILED_FETCH_BUSINESS_PROGRAM_LIST,
        payload: {
            error
        }
    };
}

export function fetchBusinessProgramDetail(id) {
    return {
        type: MPA_DPA_ACTIONS.FETCH_BUSINESS_PROGRAM_DETAIL,
        payload: {
            id
        }
    };
}

export function fetchedBusinessProgramDetail(id, data) {
    return {
        type: MPA_DPA_ACTIONS.FETCHED_BUSINESS_PROGRAM_DETAIL,
        payload: {
            id,
            data
        }
    };
}

export function failedFetchBusinessProgramDetail(error) {
    return {
        type: MPA_DPA_ACTIONS.FAILED_FETCH_BUSINESS_PROGRAM_DETAIL,
        payload: {
            error
        }
    };
}

export function fetchCompanyBusinessProgramDetail(id) {
    return {
        type: MPA_DPA_ACTIONS.FETCH_COMPANY_BUSINESS_PROGRAM_DETAIL,
        payload: {
            id
        }
    };
}

export function fetchedCompanyBusinessProgramDetail(id, data) {
    return {
        type: MPA_DPA_ACTIONS.FETCHED_COMPANY_BUSINESS_PROGRAM_DETAIL,
        payload: {
            id,
            data
        }
    };
}

export function failedFetchCompanyBusinessProgramDetail(error) {
    return {
        type: MPA_DPA_ACTIONS.FAILED_FETCH_COMPANY_BUSINESS_PROGRAM_DETAIL,
        payload: {
            error
        }
    };
}

export function createBusinessProgram(company_id, data) {
    return {
        type: MPA_DPA_ACTIONS.CREATE_BUSINESS_PROGRAM_DETAIL,
        payload: {
            company_id,
            data
        }
    };
}

export function createdBusinessProgram(id,data) {
    return {
        type: MPA_DPA_ACTIONS.CREATED_BUSINESS_PROGRAM_DETAIL,
        payload: {
            id,
            data
        }
    };
}

export function failedCreateBusinessProgram(error) {
    return {
        type: MPA_DPA_ACTIONS.FAILED_CREATE_BUSINESS_PROGRAM_DETAIL,
        payload: {
            error
        }
    };
}

export function updateBusinessProgram(id, data) {
    return {
        type: MPA_DPA_ACTIONS.UPDATE_BUSINESS_PROGRAM_DETAIL,
        payload: {
            id,
            data
        }
    };
}

export function updatedBusinessProgram(data) {
    return {
        type: MPA_DPA_ACTIONS.UPDATED_BUSINESS_PROGRAM_DETAIL,
        payload: {
            data
        }
    };
}

export function failedUpdateBusinessProgram(error) {
    return {
        type: MPA_DPA_ACTIONS.FAILED_UPDATE_BUSINESS_PROGRAM_DETAIL,
        payload: {
            error
        }
    };
}

export function createBuyerQualificationDetails(data) {
    return {
        type: MPA_DPA_ACTIONS.CREATE_BUSINESS_QUALIFICATION_DETAIL,
        payload: {
            data
        }
    };
}

export function createdBuyerQualificationDetails(data) {
    return {
        type: MPA_DPA_ACTIONS.CREATED_BUSINESS_QUALIFICATION_DETAIL,
        payload: {
            data
        }
    };
}

export function failedCreateBuyerQualificationDetails(error) {
    return {
        type: MPA_DPA_ACTIONS.FAILED_CREATE_BUSINESS_QUALIFICATION_DETAIL,
        payload: {
            error
        }
    };
}

export function updateBuyerQualificationDetails(id, data) {
    return {
        type: MPA_DPA_ACTIONS.UPDATE_BUSINESS_QUALIFICATION_DETAIL,
        payload: {
            id,
            data
        }
    };
}

export function updatedBuyerQualificationDetails(data) {
    return {
        type: MPA_DPA_ACTIONS.UPDATED_BUSINESS_QUALIFICATION_DETAIL,
        payload: {
            data
        }
    };
}

export function failedUpdateBuyerQualificationDetails(error) {
    return {
        type: MPA_DPA_ACTIONS.FAILED_UPDATE_BUSINESS_QUALIFICATION_DETAIL,
        payload: {
            error
        }
    };
}

export function createBusinessProgramInterest(data, id) {
    return {
        type: MPA_DPA_ACTIONS.CREATE_BUSINESS_INTEREST_DETAIL,
        payload: {
            data,
            id
        }
    };
}

export function createdBusinessProgramInterest(data) {
    return {
        type: MPA_DPA_ACTIONS.CREATED_BUSINESS_INTEREST_DETAIL,
        payload: {
            data
        }
    };
}

export function failedCreateBusinessProgramInterest(error) {
    return {
        type: MPA_DPA_ACTIONS.FAILED_CREATE_BUSINESS_INTEREST_DETAIL,
        payload: {
            error
        }
    };
}

export function updateBusinessProgramInterest(data) {
    return {
        type: MPA_DPA_ACTIONS.UPDATE_BUSINESS_INTEREST_DETAIL,
        payload: {
            data
        }
    };
}

export function updatedBusinessProgramInterest(data) {
    return {
        type: MPA_DPA_ACTIONS.UPDATED_BUSINESS_INTEREST_DETAIL,
        payload: {
            data
        }
    };
}

export function failedUpdateBusinessProgramInterest(error) {
    return {
        type: MPA_DPA_ACTIONS.FAILED_UPDATE_BUSINESS_INTEREST_DETAIL,
        payload: {
            error
        }
    };
}

export function createBusinessProgramFee(data) {
    return {
        type: MPA_DPA_ACTIONS.CREATE_BUSINESS_FEE_DETAIL,
        payload: {
            data
        }
    };
}

export function createdBusinessProgramFee(data) {
    return {
        type: MPA_DPA_ACTIONS.CREATED_BUSINESS_FEE_DETAIL,
        payload: {
            data
        }
    };
}

export function failedCreateBusinessProgramFee(error) {
    return {
        type: MPA_DPA_ACTIONS.FAILED_CREATE_BUSINESS_FEE_DETAIL,
        payload: {
            error
        }
    };
}

export function updateBusinessProgramFee(data) {
    return {
        type: MPA_DPA_ACTIONS.UPDATE_BUSINESS_FEE_DETAIL,
        payload: {
            data
        }
    };
}

export function updatedBusinessProgramFee(data) {
    return {
        type: MPA_DPA_ACTIONS.UPDATED_BUSINESS_FEE_DETAIL,
        payload: {
            data
        }
    };
}

export function failedUpdateBusinessProgramFee(error) {
    return {
        type: MPA_DPA_ACTIONS.FAILED_UPDATE_BUSINESS_FEE_DETAIL,
        payload: {
            error
        }
    };
}

export function createBusinessProgramFacilityDetails(data) {
    return {
        type: MPA_DPA_ACTIONS.CREATE_BUSINESS_FACILITY_DETAIL,
        payload: {
            data
        }
    };
}

export function createdBusinessProgramFacilityDetails(data) {
    return {
        type: MPA_DPA_ACTIONS.CREATED_BUSINESS_FACILITY_DETAIL,
        payload: {
            data
        }
    };
}

export function failedCreateBusinessProgramFacilityDetails(error) {
    return {
        type: MPA_DPA_ACTIONS.FAILED_CREATE_BUSINESS_FACILITY_DETAIL,
        payload: {
            error
        }
    };
}

export function updateBusinessProgramFacilityDetails(data) {
    return {
        type: MPA_DPA_ACTIONS.UPDATE_BUSINESS_FACILITY_DETAIL,
        payload: {
            data
        }
    };
}

export function updatedBusinessProgramFacilityDetails(data) {
    return {
        type: MPA_DPA_ACTIONS.UPDATED_BUSINESS_FACILITY_DETAIL,
        payload: {
            data
        }
    };
}

export function failedUpdateBusinessProgramFacilityDetails(error) {
    return {
        type: MPA_DPA_ACTIONS.FAILED_UPDATE_BUSINESS_FACILITY_DETAIL,
        payload: {
            error
        }
    };
}

export function createBusinessProgramRecourseDetails(data) {
    return {
        type: MPA_DPA_ACTIONS.CREATE_BUSINESS_RECOURSE_DETAIL,
        payload: {
            data
        }
    };
}

export function createdBusinessProgramRecourseDetails(data) {
    return {
        type: MPA_DPA_ACTIONS.CREATED_BUSINESS_RECOURSE_DETAIL,
        payload: {
            data
        }
    };
}

export function failedCreateBusinessProgramRecourseDetails(error) {
    return {
        type: MPA_DPA_ACTIONS.FAILED_CREATE_BUSINESS_RECOURSE_DETAIL,
        payload: {
            error
        }
    };
}

export function updateBusinessProgramRecourseDetails(data) {
    return {
        type: MPA_DPA_ACTIONS.UPDATE_BUSINESS_RECOURSE_DETAIL,
        payload: {
            data
        }
    };
}

export function updatedBusinessProgramRecourseDetails(data) {
    return {
        type: MPA_DPA_ACTIONS.UPDATED_BUSINESS_RECOURSE_DETAIL,
        payload: {
            data
        }
    };
}

export function failedUpdateBusinessProgramRecourseDetails(error) {
    return {
        type: MPA_DPA_ACTIONS.FAILED_UPDATE_BUSINESS_RECOURSE_DETAIL,
        payload: {
            error
        }
    };
}

export function createBusinessProgramCashBack(data) {
    return {
        type: MPA_DPA_ACTIONS.CREATE_BUSINESS_CASHBACK_DETAIL,
        payload: {
            data
        }
    };
}

export function createdBusinessProgramCashBack(data) {
    return {
        type: MPA_DPA_ACTIONS.CREATED_BUSINESS_CASHBACK_DETAIL,
        payload: {
            data
        }
    };
}

export function failedCreateBusinessProgramCashBack(error) {
    return {
        type: MPA_DPA_ACTIONS.FAILED_CREATE_BUSINESS_CASHBACK_DETAIL,
        payload: {
            error
        }
    };
}

export function updateBusinessProgramCashBack(data) {
    return {
        type: MPA_DPA_ACTIONS.UPDATE_BUSINESS_CASHBACK_DETAIL,
        payload: {
            data
        }
    };
}

export function updatedBusinessProgramCashBack(data) {
    return {
        type: MPA_DPA_ACTIONS.UPDATED_BUSINESS_CASHBACK_DETAIL,
        payload: {
            data
        }
    };
}

export function failedUpdateBusinessProgramCashBack(error) {
    return {
        type: MPA_DPA_ACTIONS.FAILED_UPDATE_BUSINESS_CASHBACK_DETAIL,
        payload: {
            error
        }
    };
}

export function createBusinessAttachments(data) {
    return {
        type: MPA_DPA_ACTIONS.CREATE_BUSINESS_ATTACHMENT_DETAIL,
        payload: {
            data
        }
    };
}

export function createdBusinessAttachments(data) {
    return {
        type: MPA_DPA_ACTIONS.CREATED_BUSINESS_ATTACHMENT_DETAIL,
        payload: {
            data
        }
    };
}

export function failedCreateBusinessAttachments(error) {
    return {
        type: MPA_DPA_ACTIONS.FAILED_CREATE_BUSINESS_ATTACHMENT_DETAIL,
        payload: {
            error
        }
    };
}

export function updateBusinessAttachments(data) {
    return {
        type: MPA_DPA_ACTIONS.UPDATE_BUSINESS_ATTACHMENT_DETAIL,
        payload: {
            data
        }
    };
}

export function updatedBusinessAttachments(data) {
    return {
        type: MPA_DPA_ACTIONS.UPDATED_BUSINESS_ATTACHMENT_DETAIL,
        payload: {
            data
        }
    };
}

export function failedUpdateBusinessAttachments(error) {
    return {
        type: MPA_DPA_ACTIONS.FAILED_UPDATE_BUSINESS_ATTACHMENT_DETAIL,
        payload: {
            error
        }
    };
}

export function createBasicDetails(data) {
    return {
        type: MPA_DPA_ACTIONS.CREATE_BUSINESS_PROGRAM_BASIC_DETAIL,
        payload: {
            data
        }
    };
}

export function createdBasicDetails(data) {
    return {
        type: MPA_DPA_ACTIONS.CREATED_BUSINESS_PROGRAM_BASIC_DETAIL,
        payload: {
            data
        }
    };
}

export function failedCreateBasicDetails(error) {
    return {
        type: MPA_DPA_ACTIONS.FAILED_CREATE_BUSINESS_PROGRAM_BASIC_DETAIL,
        payload: {
            error
        }
    };
}

export function updateBasicDetails(data) {
    return {
        type: MPA_DPA_ACTIONS.UPDATE_BUSINESS_PROGRAM_BASIC_DETAIL,
        payload: {
            data
        }
    };
}

export function updatedBasicDetails(data) {
    return {
        type: MPA_DPA_ACTIONS.UPDATED_BUSINESS_PROGRAM_BASIC_DETAIL,
        payload: {
            data
        }
    };
}

export function failedUpdateBasicDetails(error) {
    return {
        type: MPA_DPA_ACTIONS.FAILED_UPDATE_BUSINESS_PROGRAM_BASIC_DETAIL,
        payload: {
            error
        }
    };
}

export function createBusinessAgreementDetails(data) {
    return {
        type: MPA_DPA_ACTIONS.CREATE_BUSINESS_AGREEMENT_DETAIL,
        payload: {
            data
        }
    };
}

export function createdBusinessAgreementDetails(data) {
    return {
        type: MPA_DPA_ACTIONS.CREATED_BUSINESS_AGREEMENT_DETAIL,
        payload: {
            data
        }
    };
}

export function failedCreateBusinessAgreementDetails(error) {
    return {
        type: MPA_DPA_ACTIONS.FAILED_CREATE_BUSINESS_AGREEMENT_DETAIL,
        payload: {
            error
        }
    };
}

export function updateBusinessAgreementDetails(data) {
    return {
        type: MPA_DPA_ACTIONS.UPDATE_BUSINESS_AGREEMENT_DETAIL,
        payload: {
            data
        }
    };
}

export function updatedBusinessAgreementDetails(data) {
    return {
        type: MPA_DPA_ACTIONS.UPDATED_BUSINESS_AGREEMENT_DETAIL,
        payload: {
            data
        }
    };
}

export function failedUpdateBusinessAgreementDetails(error) {
    return {
        type: MPA_DPA_ACTIONS.FAILED_UPDATE_BUSINESS_AGREEMENT_DETAIL,
        payload: {
            error
        }
    };
}